module.exports = __webpack_public_path__ + "img/slide-25.6bf18813.jpeg";